import {incomplete, Domain, State, Restorer, alias, DEBUG, defaultInput} from '@acng/frontend-voyager';
import {replaceUrl} from '@acng/frontend-relativity/history';
import {noop, undefined} from '@acng/frontend-bounty/std/value.js';
import {debug} from '@acng/frontend-bounty/dom/debug.js';
import {documentElement} from '@acng/frontend-bounty/dom/document.js';

import {StateProvider} from '../../voyager/context/state.js';
import {inject} from './ng.js';
import {extend} from '@acng/frontend-bounty/object.js';
import {rootScope} from '@acng/frontend-stargazer';
import {triggerPopups} from '../../userPool/service/director.js';
import {user} from '../../user/user.js';
import {update} from '../context/search-params.js';
import {location} from 'nova';

const appStartHistoryLength = window.history.length;

const app = new State().config(incomplete);
app.params = extend(rootScope);
DEBUG: app.name = 'location';

const restore = Restorer(app);

const provide = StateProvider();

/**
 * Treat the "main" {@link State | state} of location in a special way.
 *
 * @deprecated Location states should be defined in templates. In particular,
 *   {@link Domain.globals} should not be used at all.
 */
export const main = new Domain().config(alias('main'), incomplete, defaultInput('/'));
main.globals = extend(rootScope);

location.mode = 'hash';

if (location.pathname == '/') {
  location.replace(location.hash.substring(1));
} else {
  location.replace(location.pathname);
}

/**
 * @param {angular.IAngularEvent} $evt
 */
const onLocationChangeStart = ($evt) => {
  triggerPopups();

  if (restore(inject('$location').path(), true) == undefined) {
    DEBUG: if (app.VERBOSE) console.log('Prevent location change.');

    $evt.preventDefault();
    user.guestSignup();
  }
};

const onLocationChangeSuccess = () => {
  location.replace(window.location.hash.substring(1));
  const input = location.pathname;
  restore(input);
  provide(documentElement, app);
  update();

  if (input != main.currentInput) {
    replaceUrl(`/#${main.currentInput}`);
  }
};

let removeStartListener = noop;
let removeSuccessListener = noop;

const connectLocation = () => {
  const $rootScope = inject('$rootScope');

  removeStartListener = $rootScope.$on('$locationChangeStart', onLocationChangeStart);
  removeSuccessListener = $rootScope.$on('$locationChangeSuccess', onLocationChangeSuccess);

  if (restore(location.pathname) == undefined) {
    if (location.pathname == '/') {
      const error = new Error('V-NIL');
      DEBUG: error.message = 'Forced input defines nothing!';

      throw error;
    }

    DEBUG: console.log('Replace trash URL. angular.js will trigger another round!');
    replaceUrl(`/#/`);
  } else {
    provide(documentElement, app);
  }
};

const disconnectLocation = () => {
  removeStartListener();
  removeSuccessListener();
  app.routes = [main];
  restore(undefined, true);
  provide(documentElement, app);
};

/**
 * Assign an input to the location service.
 *
 * > A.k.a. "goto(route)"
 *
 * @param {Element} element
 * @param {string | URL} input
 *
 * @returns {void}
 */
const assign = (element, input) => {
  DEBUG: if (debug(element)) console.log('assign', {input, location});
  location.assign(input);
};

/**
 * @param {string} [input]
 */
const goBack = (input) => {
  const {length} = history;
  const anchor = input && history.state?.anchors?.[input];
  const delta = anchor ? anchor - length - 1 : -1;

  if (length + delta >= appStartHistoryLength) {
    history.go(delta);
  } else {
    location.hash = input ?? `${main.defaultInput}`;
  }
};

export {connectLocation, disconnectLocation, assign, goBack};
